// https://jsfiddle.net/61stjwcf/

import {
  legend_arrows, get_legend_nodes, lanesHorizontal, lanesVertical, cellSettings
} from './grid_data';

import { buildEvents } from './grid_events';
import { buildUpdator } from '../carto/shared';

const buildChart = ({ element, height, ce_nodes, ce_links, onNodeClick, updateNode, onFullScreen}) => {
  const events = buildEvents({ lanesHorizontal, lanesVertical });

  const all_nodes = get_legend_nodes().concat(ce_nodes);
  const all_links = legend_arrows.concat(ce_links);

  const updator = buildUpdator(element);

  // https://zoomcharts.com/developers/en/time-chart/introductory-topics/toolbar.html
  // https://zoomcharts.com/developers/en/time-chart/examples/toolbar/custom-items.html
  // items: [{ item: "fullscreen", onClick: function(e, chart){ onFullScreen(chart); return false; }}]]
  // wont work... as onClick still triggers original behaviour

  const toolbar = {
    fullscreen: false,
    freeze: false,
    sticky: false,
    rearrange: false,
    back: false,
    extraItems: [{
      label: "fullScreen",
      title: "fullScreen",
      align: "left",
      side: "bottom",
      cssClass: "custom-zoomchart-fullscreen-bar-btn",
      onClick: function(e, chart){
	onFullScreen(chart)
	e.preventDefault();
      }
    }]
  };

  const chart = new window.NetChart({
    container: element,
    // area: { height },
    style: {
      //node: { display: "image", lineWidth: 5, lineColor: "red", lineDash: [50, 8] },
      link: {
	//fillColor: "red",
	//fromDecoration: "circle",
	toDecoration: "arrow",
	// orthogonalOffset: 0.5,
	// arcAmount: 30
      },

      nodeLabel: { backgroundStyle: { fillColor: 'orange' } },
    },
    layout: {
      mode: "swimlane",
      swimlane: {
	lineWidth: 2,
	laneSpreadX: 200,
	laneSpreadY: 200,
	lineColor: "rgba(255,255,255,0.25)",
	labelAlign: "center",
	labelSideVertical: "bottom",
	labelSideHorizontal: "left",
	boxFillColor: "rgba(255,255,255,0.25)",
	boxHeight: 0,
	labelStyle: {
	  borderRadius: 30,
	  angle: 0,
	  textStyle: {
	    font:"12px Manrope-Medium",
	    outlineWidth: 2,
	    outlineColor: "rgba(255,255,255,0.25)"
	  },
	  backgroundStyle: {
	    fillColor: "rgba(255.0,0.0,0.0,0)",
	    shadowColor: "#000",
	    shadowOffsetX: 0,
	    shadowOffsetY: 0,
	    shadowBlur: 0
	  }
	},
	lanesHorizontal,
	lanesVertical,
	cellSettings
      }
    },
    toolbar,
    //,		randomNodes: 1,    randomLinks: 0
    data: [
      { preloaded: { "nodes": all_nodes, "links": all_links } },
    ],
    events: {
      onHoverChange: (e) => {
	const node = e.hoverNode;
	if (node?.data?.type) {
	  updator.onHoverChange({
	    hoverNode: node,
	    force_text: node.data.hoverText,
	    x: e.x,
	    y: e.y
	  })
	} else {
	  updator.onHoverChange({ hoverNode: null });
	}
      },
      onSettingsChange: (e, args) => { updator.update(e, args); },
      onPointerDrag: (e, args) => {
	updator.update(e, args);
	// console.log("onPointerDrag");
	// events.onPointerDrag(chart, e);
      },
      onChartUpdate: (e, args) => {
	updator.update(e, args);
	// theme_tiled_loader(e.chart);
      },
      onPositionChange: updator.update,
      onPointerMove: (e) => {
	// console.log("onPointerMove");
	// events.onPointerMove(chart, e);
      },
      onPointerDown: (e) => {
	// console.log("onPointerDown");
	// events.onPointerDown(chart, e);
      },
      // https://zoomcharts.com/developers/en/net-chart/examples/events/connect-nodes-by-dragging.html
      // after drag end
      onPointerUp: (e, args) => {
	if (args.clickNode) {
	  const node = args.clickNode;

	  // only dragable are updatable
	  if (node.data?.style?.draggable) {
	    updateNode(chart, node, {nodes: all_nodes, links: all_links});
	  }
	}
      },
      onClick: (e) => {
	onNodeClick(e);
      }, 
    },
  });

  updator.setChart(chart);

  return {
    chart: chart
  }
}


export { buildChart };
